export default __webpack_public_path__ + "static/media/lso.8020bf42.png";